import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('appointment-form', 'accept-consent');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'appointments',
  type: 'post',
  slug: [
    'consents',
    {
      type: 'payload',
      selector: ['concentId'],
    },
    'user_consent_info',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/accept-consent-req.js